/* eslint-disable */
import 'viewerjs/dist/viewer.css';
import VueViewer from 'v-viewer';
import Vue from 'vue';
Vue.use(VueViewer);
export default {
  data() {
    return {
      heraUrl: process.env.VUE_APP_HERA_LINK,
    };
  },
  computed: {
    language() {
      return this.$store.state.language;
    },
  },
  mounted() {},
  methods: {
    formatRupiah(number) {
      if (number !== undefined) {
      const stringNumber = number.toString();
      const numberString = stringNumber.replace(/[^,\d]/g, '').toString();
      const split = numberString.split(',');
      const remain = split[0].length % 3;
      let rupiah = split[0].substr(0, remain);
      const ribuan = split[0].substr(remain).match(/\d{3}/gi);

      // adding dot if value input has been thousand
      if (ribuan) {
        const separator = remain ? '.' : '';
        rupiah += separator + ribuan.join('.');
      }
      
      rupiah = split[1] !== undefined ? `${rupiah},${split[1]}` : rupiah;
      rupiah = `Rp. ${rupiah}`;
      return rupiah;
    } else {
      return "Rp. 0";
    }
    },
    epochToDateTime(epoch) {
      const date = new Date(epoch);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}`;
    },
    generateID() {
      const date = new Date();
      const day = (`0${date.getDate()}`).slice(-2);
      const month = (`0${date.getMonth() + 1}`).slice(-2);
      const year = date.getFullYear().toString().substr(-2);
      const random = Math.random().toString(36).substring(2, 6).toUpperCase();
      return `INV-DOL-${day}${month}${year}-${random}`;
    },
    swal_alert(message) {
      this.$swal({
        title:
          "<label style='color:white;font-size:12px;text-align:center;z-index:99999999;word-break: break-all; align-items: center;vertical-align: middle;margin-bottom:0px!important'> " +
          message +
          "</label>",
        toast: true,
        showClass: {
          popup: "animate__animated animate__slideInUp",
        },
        hideClass: {
          popup: "animate__animated animate__slideOutDown",
        },
        width: 300,
        padding: "5px",
        background: "rgba(000, 000, 000, 0.5)",
        showConfirmButton: false,
        timer: 3000,
      });
    },
    async copy_to_clipboard(text) {
      var dummy = document.createElement("input");
      document.body.appendChild(dummy);
      dummy.value = text;
      dummy.select();
      document.execCommand("copy");
      this.swal_alert("Berhasil disalin");
      document.body.removeChild(dummy);
    },
    imageUrlNoContent(event) {
      event.target.src = require("@/assets/images/img-nocontent.svg");
    },
    epochToDateTimeLocalFormat(epoch, is_return_array = false){
      let locale = "id-ID"
      if (this.language == 'en') {
        locale = "en-US"
      }
      if(epoch){
        const date = new Date(epoch);
        const year = date.getFullYear();
        const month = date.toLocaleDateString(locale, { month: 'short' });
        const dayname = date.toLocaleDateString(locale, { weekday: 'short' });
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        if(is_return_array){
          const ret_date = {
            date: `${day} ${month} ${year}`,
            time: `${hours}:${minutes}`
          }
          return ret_date
        }else{
          return `${day} ${month} ${year} | ${hours}:${minutes}`;
        }
      }else{
        return "-"
      }
    },
    base64ToBlob(base64String) {
      let byteString = atob(base64String.split(',')[1]);
      let ab = new ArrayBuffer(byteString.length);
      let ia = new Uint8Array(ab);
      for (let i = 0; i < byteString.length; i++) {
          ia[i] = byteString.charCodeAt(i);
      }
      return new Blob([ab], { type: 'image/png' }); // Change 'image/png' to match your image type
    },
    objectToQuery({ obj, defaultQuery = {}, options = { encode: true } }) {
      const str = [];

      const pushToStr = ({ obj, key }) => {
        if (options.encode) {
          str.push(
            encodeURIComponent(key) + "=" + encodeURIComponent(obj[key])
          );
        } else {
          str.push(key + "=" + obj[key]);
        }
      };
      // add queries value
      for (const key in obj) {
        // consider zero as a value
        if (
          Object.prototype.hasOwnProperty.call(obj, key) &&
          (obj[key] || obj[key] === 0)
        ) {
          pushToStr({
            obj,
            key,
          });
        }
      }

      // compare to obj value, if obj value not exist
      // the default value will fill it
      if (Object.keys(defaultQuery).length) {
        for (const keyDefault in defaultQuery) {
          // consider zero as a value
          if (!obj?.[keyDefault] && obj?.[keyDefault] !== 0) {
            pushToStr({
              obj: defaultQuery,
              key: keyDefault,
            });
          }
        }
      }

      return "?" + str.join("&");
    },
    sizeDoorLabel(size_code){
      let sizeString = ""
      if(size_code == "L"){
        sizeString = "Large"
      }else if (size_code == "M"){
        sizeString = "Medium"
      }else if(size_code == "S"){
        sizeString = "Small"
      }else if(size_code == "XL"){
        sizeString = "Extra Large"
      }else if(size_code == "S Food"){
        sizeString = "Small Food"
      }else if(size_code == "M Food"){
        sizeString = "Medium Food"
      }else if(size_code == "L Food"){
        sizeString = "Large Food"
      }else if(size_code == "XL Food"){
        sizeString = "Extra Large Food"
      }else if(size_code == "SELIBOX"){
        sizeString = "Seli Box"
      }
      return sizeString;
    },
    getPaxelBoxContentSetting(key){
      let settings = this.$store.getters.getSettings;
      if(settings){
        let paxelboxContent = settings.paxelbox_content;
        let val = ""
        paxelboxContent.forEach(element => {
          if(element.name == key){
            val = element.setting_value;
          }
        });
        return val
      }else{
        return {}
      }
    },
    getSettingValue(group, name){
      let settings = this.$store.getters.getSettings;
      if(settings){
        let groupSetting = settings[group];
        let val = ""
        groupSetting.forEach(element => {
          if(element.name == name){
            val = element.setting_value;
          }
        });
        return val
      }else{
        return {}
      }
    },
    getStatusDisplayName(status, is_stop_without_scan = false){
      if (status === 'IN_STORE') {
				return {
					text: this.language === 'en' ? 'Storing Items' : 'Menyimpan Barang',
					color: '#FFB003',
				};
			} else if (status === 'IMPORTED') {
				return {
					text: this.language === 'en' ? 'Waiting to be Opened' : 'Menunggu Dibuka',
					color: '#56c378',
				};
			} else if (status === 'CUSTOMER_TAKEN') {
          let text = this.language === 'en' ? 'Rent Ended by Customer' : 'Sewa Selesai'
          if (is_stop_without_scan) {
            text = this.language === 'en' ? 'Rent Ended without Scan QR' : 'Sewa Selesai Tanpa Scan QR'
          }
          return {
            text: text,
            color: '#5e51a1',
          };
			} else if (status === 'CANCEL') {
				return {
					text: this.language === 'en' ? 'Cancelled' : 'Dibatalkan',
					color: '#FF434F',
				};
			} else if (status === 'TAKEN_BY_SYSTEM') {
				return {
					text: this.language === 'en' ? 'Rent Ended by System' : 'Diakhiri Sistem' ,
					color: '#5e51a1',
				};
			} else if (status === 'OPERATOR_TAKEN' || status === 'OPERATOR_PICK') {
				return {
					text: this.language === 'en' ? 'Operator Picked Item(s)' : 'Barang Diambil Petugas' ,
					color: '#5e51a1',
				};
			}else{
        return {
					text: status ,
					color: '#5e51a1',
				};
      }
    },
    showPhoto(imageUrl){
      this.$router.push(`${this.$route.fullPath}&preview=true`);
      this.$viewerApi({
        options: {
          button: false,
          navbar: false,
          title: false,
          toolbar: false,
          tooltip: false,
          movable: false,
          zoomable: true,
          rotatable: false,
          scalable: true,
          transition: true,
          fullscreen: true,
          keyboard: false,
          hidden: (e) => {
            this.onHide(e);
          },
        },
        images: [imageUrl],
      });
    },
    onHide() {
      if (this.$route.query.preview) {
        this.$router.go(-1);
      }
    },
    jsonParse(string_object){
      if(string_object){
        try {
          let obj = JSON.parse(string_object)
          return obj
        } catch (error) {
          return false          
        }
      }else{
        return false
      }
    },
    generalEventPayloadData(is_include_donation = false){
      if(this.$store.getters.getOrderDetail){
				let rentalDetail = this.$store.getters.getOrderDetail
        let netcorePayload = {
          Locker_Code : rentalDetail.mouth.box.name,
          Locker_Address: rentalDetail.mouth.box.address,
          Locker_Size : rentalDetail.mouth?.mouthType?.name,
          Rent_Duration : rentalDetail.rentTime+" "+rentalDetail.rentTimeUnit,
          Rent_Cost : rentalDetail.mouth.mouthType.defaultUsePrice,
          app_version : "",
          Rent_Order_Number : rentalDetail.expressNumber, 
					Door_Number : rentalDetail.mouth.number
        }
        if(is_include_donation){
          let donation = rentalDetail.donation
          if(donation && donation.length > 0) {
            netcorePayload.donation = "";
            let donationFormat = "";
            let donationNameFormat = "";
            let donationQuantityFormat = "";
            let donationAmountFormat = "";
            for (let i = 0; i < donation.length; i++) {
              if(i > 0){
                donationFormat += " | ";
                donationNameFormat += " | ";
                donationQuantityFormat += " | ";
                donationAmountFormat += " | ";
              }
              let donation_name = this.language == 'en'? rentalDetail.donation[i].name.en :rentalDetail.donation[i].name.id

              donationFormat += `${donation_name} | ${rentalDetail.donation[i].qty} | ${rentalDetail.donation[i].donation_amount}`
              donationNameFormat += `${donation_name}`;
              donationQuantityFormat += `${rentalDetail.donation[i].qty}`;
              donationAmountFormat += `${rentalDetail.donation[i].donation_amount}`;
                
            }
            netcorePayload.donation = donationFormat;
            netcorePayload.donation_name = donationNameFormat;
            netcorePayload.donation_quantity = donationQuantityFormat;
            netcorePayload.donation_amount = donationAmountFormat;
          }
        }
        return netcorePayload;
      }else{
        return [];
      }
    },
  },
};
